"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  PageWrapper: true,
  PageTitle: true,
  FAQsTable: true,
  useThemeScreenSize: true,
  useScreenSize: true,
  useElementSize: true,
  useSwipe: true,
  useElementScroll: true
};
exports.PageWrapper = exports.PageTitle = exports.FAQsTable = void 0;
Object.defineProperty(exports, "useElementScroll", {
  enumerable: true,
  get: function get() {
    return _useElementScroll["default"];
  }
});
Object.defineProperty(exports, "useElementSize", {
  enumerable: true,
  get: function get() {
    return _useElementSize["default"];
  }
});
Object.defineProperty(exports, "useScreenSize", {
  enumerable: true,
  get: function get() {
    return _useScreenSize["default"];
  }
});
Object.defineProperty(exports, "useSwipe", {
  enumerable: true,
  get: function get() {
    return _useSwipe["default"];
  }
});
Object.defineProperty(exports, "useThemeScreenSize", {
  enumerable: true,
  get: function get() {
    return _useThemeScreenSize["default"];
  }
});
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _useThemeScreenSize = _interopRequireWildcard(require("./useThemeScreenSize"));
Object.keys(_useThemeScreenSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useThemeScreenSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useThemeScreenSize[key];
    }
  });
});
var _useScreenSize = _interopRequireDefault(require("./useScreenSize"));
var _useElementSize = _interopRequireDefault(require("./useElementSize"));
var _useSwipe = _interopRequireDefault(require("./useSwipe"));
var _useElementScroll = _interopRequireDefault(require("./useElementScroll"));
var _cursor = require("./cursor");
Object.keys(_cursor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _cursor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _cursor[key];
    }
  });
});
var _mixBlendMode = require("./mixBlendMode");
Object.keys(_mixBlendMode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _mixBlendMode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _mixBlendMode[key];
    }
  });
});
var _Breakpoint = require("./Breakpoint");
Object.keys(_Breakpoint).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Breakpoint[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Breakpoint[key];
    }
  });
});
var _getDynamicVariant = require("./getDynamicVariant");
Object.keys(_getDynamicVariant).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getDynamicVariant[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getDynamicVariant[key];
    }
  });
});
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
//
var PageWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tpadding: 1rem;\n\twidth: 100%;\n\t@media (min-width: 1024px) {\n\t\tpadding: 4.25rem 5.75rem;\n\t}\n"])));
exports.PageWrapper = PageWrapper;
var PageTitle = _styledComponents["default"].h2(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tfont-size: 2rem;\n\tfont-weight: 500;\n\tline-height: 1.2;\n\tmargin: 1rem 0;\n"])));
exports.PageTitle = PageTitle;
var FAQsTable = (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t.table {\n\t\twidth: 100%;\n\t\tmargin-bottom: 1rem;\n\t\tcolor: #212529;\n\t\ttable-layout: fixed;\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 0.75rem;\n\t\t\tvertical-align: top;\n\t\t\tborder-top: 1px solid #dee2e6;\n\t\t\ttext-align: inherit;\n\t\t}\n\t}\n"])));
exports.FAQsTable = FAQsTable;